// Shared "does this role have both Visitor Office and Front Desk access at once" check — used by
// Navigation/index.js (to decide the grouped Admin sidebar vs the flat single-office-type one and
// the Master/Reports label prefixes) and NavCard.js/NavCardIcon.js (to decide whether to show one
// "Check-In" button or the two Front Desk / VMS check-in buttons).
const hasModulePermission = (permissions, module, permission) => {
  const moduleData = permissions.find((mod) => mod.module_name === module);
  if (!moduleData) return false;
  const allowedPermissions = moduleData.permissions?.map((perm) => perm.name) || [];
  return Array.isArray(permission) ? permission.some((perm) => allowedPermissions.includes(perm)) : allowedPermissions.includes(permission);
};

export const hasBothOfficeTypes = (permissions) => {
  if (!Array.isArray(permissions)) return false;

  const hasFrontDeskAccess =
    hasModulePermission(permissions, 'visitor/courier', 'summary') ||
    hasModulePermission(permissions, 'department', 'summary') ||
    hasModulePermission(permissions, 'office', 'summary') ||
    hasModulePermission(permissions, 'employee', 'summary') ||
    hasModulePermission(permissions, 'id proof type', 'summary') ||
    hasModulePermission(permissions, 'purpose of visit', 'summary') ||
    hasModulePermission(permissions, 'report', 'visitor') ||
    hasModulePermission(permissions, 'report', 'department');

  const hasVisitorOfficeAccess =
    hasModulePermission(permissions, 'vendor', 'summary') ||
    hasModulePermission(permissions, 'interest', 'summary') ||
    hasModulePermission(permissions, 'report', 'visitor history') ||
    hasModulePermission(permissions, 'report', 'project') ||
    hasModulePermission(permissions, 'report', 'cross selling');

  return hasFrontDeskAccess && hasVisitorOfficeAccess;
};
